import React from 'react'
import PropTypes from 'prop-types'

import StyledWrapper from './StyledWrapper'
import ShowAloAccessStatus from 'components_v2/Membership/Edit/ShowAloAccessStatus'

const EditMembershipWrapper = ({ user, ...rest }) => {
  return (
    <StyledWrapper user={user} mb='100px'>
      <ShowAloAccessStatus aloLinkedStatus={user?.aloLinkedStatus} />
    </StyledWrapper>
  )
}

EditMembershipWrapper.propTypes = {
  user: PropTypes.object
}

export default EditMembershipWrapper
